export default __webpack_public_path__ + "static/media/favicon.b5046107.png";